import ACTIONS from "../constants/actions/index";

const {
  GET_GENERAL_SETTING_REQUEST,
  GET_GENERAL_SETTING_SUCCESS,
  GET_GENERAL_SETTING_ERROR,
} = ACTIONS;

const initialState = {
  generalSetting: [],
  loading: false,
};

const GeneralSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GENERAL_SETTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_GENERAL_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        generalSetting: action.payload,
      };
    case GET_GENERAL_SETTING_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
export default GeneralSettingReducer;
